import React from 'react';

import Typography from '@mui/material/Typography';

import { RenderElementProps } from 'slate-react';

import { GROUPING_OPERATOR_COLOR } from '../constants';
import { GroupingOperatorElement as GroupingOperatorElementType } from '../types';

export const GroupingOperatorElement: React.FC<RenderElementProps> = ({
  attributes,
  children,
  element,
}) => {
  const opElement = element as GroupingOperatorElementType;

  return (
    <Typography
      component="span"
      variant="body2"
      {...attributes}
      contentEditable={false}
      sx={{
        alignItems: 'center',
        color: GROUPING_OPERATOR_COLOR,
        display: 'inline-flex',
        whiteSpace: 'normal',
      }}
    >
      {opElement.operator}

      {children}
    </Typography>
  );
};
